/**
 * State used in rendering ToastFooter
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
